import { Bubble as AntdBubble, BubbleProps as AntdBubbleProps } from '@ant-design/x'

import styles from './index.module.scss'

const Bubble = (props: AntdBubbleProps) => {
  // 如果 typing 是 true，转换为快速打字配置
  const typingConfig =
    props.typing === true
      ? { step: 1, interval: 30 } // 每次打1个字符，间隔30ms
      : props.typing

  return (
    <div className={styles.container}>
      <AntdBubble {...props} typing={typingConfig} />
    </div>
  )
}

export default Bubble
